// extracted by mini-css-extract-plugin
export default {"authenticationBox":"styles_authenticationBox__s6Tqd","container":"styles_container__Z+zK+"};